var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCommunicationSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 195.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00d2ff;\n      }\n\n      .cls-2 {\n        fill: blue;\n      }\n\n      .cls-3 {\n        fill: #000062;\n      }\n\n      .cls-4 {\n        fill: #7f92ff;\n      }\n\n      .cls-5 {\n        fill: #5e1ad5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.87,56.54h13.25c.06,0,.11,0,.17,0,.02,0,.05,0,.06,0,2.79-.04,5.34-.7,7.65-2.03,2.34,1.33,4.89,1.99,7.65,2.03,.02,0,.05,0,.07,0,.06,0,.11,0,.17,0h.07c.06,0,.12,0,.18,0,.02,0,.04,0,.05,0,2.79-.04,5.35-.7,7.65-2.03,2.41,1.37,5.03,2.04,7.88,2.04h26.53c2.89,0,5.51-.67,7.88-2.04,2.34,1.33,4.89,1.99,7.65,2.03,.02,0,.05,0,.07,0,.05,0,.11,0,.16,0h.07s.02,0,.04,0c.13,0,.23,0,.31-.02,3.91-.09,7.6-1.67,9.76-3.83V29.53h-4.4v21.28c-1.48,.78-3.66,1.18-5.73,1.18s-4.22-.41-5.7-1.18v-12.77h-4.4v12.77c-1.59,.78-3.48,1.18-5.73,1.18h-7.58c2.48-1.96,3.74-4.44,3.74-7.36,0-5.07-3.85-8.47-9.36-8.47s-9.4,3.4-9.4,8.47c0,2.92,1.26,5.4,3.74,7.36h-7.58c-2.11,0-4.22-.41-5.7-1.18v-12.77h-4.4v12.77c-1.59,.78-3.48,1.18-5.73,1.18-2.11,0-4.22-.41-5.7-1.18v-12.77h-4.4v12.77c-1.59,.78-3.48,1.18-5.74,1.18h-5.62v-12.28c-1.92-1.07-5-2.04-8.1-2.04-6.07,0-10.1,3.66-10.1,9.44s4.22,9.44,10.62,9.44Zm58.13-16.17c2.92,0,4.96,1.89,4.96,4.81,0,1.44-.52,2.74-1.52,3.81s-2.15,1.85-3.44,2.41c-1.33-.52-2.52-1.33-3.52-2.41-1-1.07-1.48-2.37-1.48-3.81,0-2.85,2.07-4.81,5-4.81Zm-58.98,1.44c1.52,0,2.89,.3,4.03,.93v9.25h-3.81c-3.4,0-5.62-1.78-5.62-5.03s2.29-5.14,5.4-5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.8,34.45c1.44,0,2.63-1.18,2.63-2.66s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.02,34.45c1.48,0,2.66-1.18,2.66-2.66s-1.18-2.66-2.66-2.66-2.63,1.18-2.63,2.66,1.15,2.66,2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M289.07,61.9c0,1.44,1.15,2.63,2.63,2.63s2.67-1.18,2.67-2.63c0-1.52-1.18-2.66-2.67-2.66s-2.63,1.15-2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.48,64.53c1.44,0,2.63-1.18,2.63-2.63s-1.15-2.66-2.63-2.66-2.7,1.15-2.7,2.66,1.18,2.63,2.7,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.91,34.71c1.48,0,2.66-1.18,2.66-2.66s-1.18-2.7-2.66-2.7-2.7,1.18-2.7,2.7,1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.37,32.93c1.44,0,2.63-1.18,2.63-2.67s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.67,2.7,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.59,32.93c1.48,0,2.66-1.18,2.66-2.67s-1.18-2.66-2.66-2.66-2.63,1.18-2.63,2.66,1.15,2.67,2.63,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.61,34.71c1.44,0,2.63-1.18,2.63-2.66s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.83,34.71c1.48,0,2.67-1.18,2.67-2.66s-1.18-2.66-2.67-2.66-2.63,1.18-2.63,2.66,1.15,2.66,2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 371.66,
    y: 29.53,
    width: 4.4,
    height: 27.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.64,56.54h3.22c-.26,3.66-2.15,5.4-6.4,5.4-2.18,0-4.51-.48-5.96-1.04l-.78,4.18c1.96,.7,4.4,1.07,6.59,1.07,6.77,0,10.95-3.37,10.95-10.92v-14.84c-2.7-1.37-5.44-2.04-8.14-2.04-6.18,0-10.14,3.7-10.14,9.14s3.96,9.03,10.66,9.03Zm-.78-14.06c1.37,0,2.7,.3,4,.93v8.58h-3.92c-3.29,0-5.59-1.74-5.59-4.74s2.29-4.77,5.51-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.97,51.99h-5.37c-2.48-.26-4.03-1.44-4.03-3.96,0-2.26,1.29-3.55,3.33-3.55,1,0,1.89,.33,2.59,.96l2.96-2.78c-1.37-1.29-3.51-2.15-5.77-2.15-4.18,0-7.07,3-7.07,6.99,0,1.78,.52,3.26,1.59,4.48h-3.59v4.55h15.36v-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.26,54.54c2.06,1.15,4.93,1.95,8.09,1.99,.03,0,.07,0,.11,0,.04,0,.09,0,.13,0h64.19c4.03,0,7.88-1.63,10.1-3.85V29.53h-4.4v21.28c-1.48,.78-3.66,1.18-5.74,1.18h-7.58c2.48-1.96,3.74-4.44,3.74-7.36,0-5.07-3.85-8.47-9.36-8.47s-9.4,3.4-9.4,8.47c0,2.92,1.26,5.4,3.74,7.36h-12.99v-4.96c0-3.29-.85-5.85-2.55-7.59-1.67-1.74-3.88-2.63-6.66-2.63-4.48,0-8.36,2.37-12.91,7.07v-4.44h-4.4v12.54h-5.73c-2.11,0-4.22-.41-5.74-1.18V29.53h-4.4v21.98c0,1.59,.44,2.33,1.78,3.03Zm59.27-14.17c2.92,0,4.96,1.89,4.96,4.81,0,1.44-.52,2.74-1.52,3.81s-2.15,1.85-3.44,2.41c-1.33-.52-2.52-1.33-3.52-2.41s-1.48-2.37-1.48-3.81c0-2.85,2.07-4.81,5-4.81Zm-40.77,8.92c4.85-5.62,8.47-8.18,12.21-8.18,1.96,0,3.37,.63,4.22,1.89,.89,1.26,1.33,2.85,1.33,4.74v4.25h-17.76v-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.05,33.49c1.48,0,2.66-1.18,2.66-2.66s-1.18-2.7-2.66-2.7-2.7,1.18-2.7,2.7,1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M498.49,32.93c1.48,0,2.66-1.18,2.66-2.67s-1.18-2.7-2.66-2.7-2.7,1.18-2.7,2.7,1.18,2.67,2.7,2.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 529.35,
    y: 29.53,
    width: 4.4,
    height: 27.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M550.33,56.54h3.22c-.26,3.66-2.15,5.4-6.4,5.4-2.18,0-4.51-.48-5.96-1.04l-.78,4.18c1.96,.7,4.4,1.07,6.59,1.07,6.77,0,10.95-3.37,10.95-10.92v-14.84c-2.7-1.37-5.44-2.04-8.14-2.04-6.18,0-10.14,3.7-10.14,9.14s3.96,9.03,10.66,9.03Zm-.78-14.06c1.37,0,2.7,.3,4,.93v8.58h-3.92c-3.29,0-5.59-1.74-5.59-4.74s2.29-4.77,5.51-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M584.15,56.54h14.62c5.29,0,9.51-.93,11.99-2.26v-16.24h-4.4v12.88c-1.33,.63-3.85,1.07-6.96,1.07h-14.95c-4.44,0-6.66-1.89-6.66-5.66,0-1.26,.22-2.74,.7-4.4l-4.03-.74c-.7,2.29-1.04,4.44-1.04,6.44,0,6.48,3.92,8.92,10.73,8.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M595.77,39.26c1.48,0,2.67-1.18,2.67-2.66s-1.18-2.66-2.67-2.66-2.63,1.18-2.63,2.66,1.15,2.66,2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.55,39.26c1.44,0,2.63-1.18,2.63-2.66s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M637.5,52.69V29.53h-4.4v21.05c-1.29,.89-3.11,1.37-5.44,1.41l-4.14-17.72h-4.37l4.07,17.72h-7.1v4.55h11.36c4.03,0,7.81-1.63,10.03-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M646.75,54.54c2.06,1.15,4.93,1.95,8.09,1.99,.03,0,.07,0,.11,0,.04,0,.09,0,.13,0h37.74s.06,0,.09,0c.06,0,.11,0,.16,0,1.87-.02,3.71-.27,5.45-.77,1.81-.52,3.29-1.15,4.4-1.92v-15.8h-4.4v12.99c-1.29,.59-3.48,.96-5.74,.96h-5.4v-4.96c0-3.29-.85-5.85-2.55-7.59-1.67-1.74-3.88-2.63-6.66-2.63-4.48,0-8.36,2.37-12.91,7.07v-4.44h-4.4v12.54h-5.73c-2.11,0-4.22-.41-5.74-1.18V29.53h-4.4v21.98c0,1.59,.44,2.33,1.78,3.03Zm18.5-5.25c4.85-5.62,8.47-8.18,12.21-8.18,1.96,0,3.37,.63,4.22,1.89,.89,1.26,1.33,2.85,1.33,4.74v4.25h-17.76v-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M697,34.71c1.44,0,2.63-1.18,2.63-2.66s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M704.21,34.71c1.48,0,2.66-1.18,2.66-2.66s-1.18-2.66-2.66-2.66-2.63,1.18-2.63,2.66,1.15,2.66,2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M729.67,52.69V29.53h-4.4v21.05c-1.29,.89-3.11,1.37-5.44,1.41l-4.14-17.72h-4.37l4.07,17.72h-7.1v4.55h11.36c4.03,0,7.81-1.63,10.03-3.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 737.14,
    y: 29.53,
    width: 4.4,
    height: 27.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M770.48,34.45c1.48,0,2.66-1.18,2.66-2.66s-1.18-2.66-2.66-2.66-2.63,1.18-2.63,2.66,1.15,2.66,2.63,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M763.26,34.45c1.44,0,2.63-1.18,2.63-2.66s-1.18-2.66-2.63-2.66c-1.52,0-2.7,1.18-2.7,2.66s1.18,2.66,2.7,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M792.42,31.67h-2.15c-1.59,0-2.33-.67-2.33-1.67,0-.78,.55-1.41,1.41-1.41,.44,0,.85,.15,1.18,.44l1.59-1.7c-.7-.7-1.78-1.26-3.07-1.26-2.07,0-3.52,1.48-3.52,3.37,0,.85,.3,1.59,.85,2.22h-1.78v2.89h7.81v-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M803.41,61.9c0-1.48-1.15-2.66-2.63-2.66s-2.7,1.15-2.7,2.66,1.18,2.63,2.7,2.63,2.63-1.18,2.63-2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M808,59.24c-1.48,0-2.63,1.15-2.63,2.66s1.15,2.63,2.63,2.63,2.66-1.18,2.66-2.63c0-1.52-1.18-2.66-2.66-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M835.71,35.74c-2.85-2.48-6.59-3.74-11.25-3.74-1.48,0-3.03,.11-4.63,.33v4.07c1.48-.26,3-.41,4.51-.41,3.26,0,5.96,.89,8.07,2.63,2.11,1.74,3.18,4.59,3.18,8.55v4.85h-6.03c1.37-1.44,2.04-3.18,2.04-5.29,0-4.48-3.52-7.4-7.88-7.4s-7.81,2.85-7.81,7.4c0,2.11,.67,3.88,2,5.25h-5.7c-2.11,0-4.22-.41-5.7-1.18v-12.77h-4.4v12.77c-1.59,.78-3.48,1.18-5.74,1.18-2.11,0-4.22-.41-5.7-1.18v-12.77h-4.4v12.77c-1.59,.78-3.48,1.18-5.74,1.18h-5.62v-12.28c-1.92-1.07-5-2.04-8.1-2.04-6.07,0-10.1,3.66-10.1,9.44s4.22,9.44,10.62,9.44h13.25c.06,0,.11,0,.17,0,.02,0,.05,0,.06,0,2.79-.04,5.34-.7,7.65-2.03,2.34,1.33,4.89,1.99,7.65,2.03,.02,0,.05,0,.07,0,.05,0,.11,0,.16,0h.07c.06,0,.12,0,.17,0,.02,0,.04,0,.06,0,2.79-.04,5.35-.7,7.65-2.03,2.34,1.33,4.89,1.99,7.65,2.03,.02,0,.04,0,.06,0,.06,0,.11,0,.17,0h27.83v-9.14c0-5.29-1.44-9.18-4.29-11.66Zm-65.2,16.24h-3.81c-3.4,0-5.62-1.78-5.62-5.03s2.29-5.14,5.4-5.14c1.52,0,2.89,.3,4.03,.93v9.25Zm53.21,0c-2.48-.33-3.81-2.15-3.81-4.7,0-2.41,1.63-4,3.81-4s3.81,1.59,3.81,4c0,2.63-1.29,4.37-3.81,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M269.81,90.78c2.65,0,5.11,1.21,6.69,3.23l3.97-2.5c-2.46-3.23-6.39-5.22-10.69-5.22-7.27-.15-13.67,6.1-13.52,13.23-.15,7.13,6.25,13.37,13.52,13.23,4.3,0,8.23-1.98,10.69-5.22l-3.97-2.57c-1.65,2.06-4.04,3.31-6.69,3.31-4.81,0-8.52-3.93-8.52-8.74s3.71-8.74,8.52-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298.51,93.65c-5.69,0-10.18,4.15-10.18,9.55s4.48,9.55,10.18,9.55c5.69,.11,10.36-4.23,10.25-9.55,.11-5.33-4.56-9.66-10.25-9.55Zm0,15.28c-3.27,0-5.77-2.5-5.77-5.73s2.5-5.73,5.77-5.73,5.84,2.5,5.84,5.73-2.5,5.73-5.84,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.87,97.29c2.35,0,3.78,1.51,3.78,4.19v10.91h4.48v-12.2c0-4.22-2.68-6.54-6.54-6.54-2.83,0-5.22,.81-7.75,2.98-1.03-1.95-3.05-2.98-5.51-2.98s-4.92,.96-7.13,2.87v-2.5h-4.48v18.37h4.48v-13.12c1.76-1.43,3.27-1.98,5.18-1.98,2.35,0,3.82,1.51,3.82,4.19v10.91h4.45v-10.55c0-.92-.07-1.8-.26-2.57,1.62-1.32,3.45-1.98,5.47-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.52,93.65c-2.83,0-5.22,.81-7.75,2.98-1.03-1.95-3.05-2.98-5.51-2.98s-4.92,.96-7.13,2.87v-2.5h-4.48v18.37h4.48v-13.12c1.76-1.43,3.27-1.98,5.18-1.98,2.35,0,3.82,1.51,3.82,4.19v10.91h4.45v-10.55c0-.92-.07-1.8-.26-2.57,1.62-1.32,3.45-1.98,5.47-1.98,2.35,0,3.78,1.51,3.78,4.19v10.91h4.48v-12.2c0-4.22-2.68-6.54-6.54-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.57,106.8c-1.65,1.47-3.75,2.28-5.7,2.28-2.65,0-4.11-1.51-4.11-4.15v-10.91h-4.45v12.2c0,4.08,2.53,6.54,6.69,6.54,2.65,0,5.33-.96,7.57-2.72v2.35h4.48v-18.37h-4.48v12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M442.19,101.48v10.91h4.45v-12.2c0-4.08-2.53-6.54-6.69-6.54-2.61,0-5.33,.96-7.57,2.68v-2.31h-4.48v18.37h4.48v-12.79c1.65-1.47,3.75-2.31,5.7-2.31,2.65,0,4.11,1.54,4.11,4.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 456.52,
    y: 94.02,
    width: 4.45,
    height: 18.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.72,87.07c-1.36,0-2.46,.99-2.46,2.28s1.1,2.28,2.46,2.28,2.43-.99,2.43-2.28c0-1.21-1.1-2.28-2.43-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.22,108.93c-3.12,0-5.59-2.53-5.59-5.73s2.46-5.73,5.59-5.73c1.84,0,3.31,.63,4.45,1.91l3.42-1.91c-1.87-2.39-4.81-3.82-7.94-3.82-5.29-.11-9.99,4.37-9.88,9.55-.11,5.18,4.59,9.66,9.88,9.55,3.23,0,6.17-1.47,8.08-3.97l-3.45-1.91c-1.07,1.32-2.65,2.06-4.56,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.08,93.65c-2.98,0-5.95,.81-8.49,2.39l1.43,3.12c1.95-1.29,3.97-1.95,6.03-1.95,2.9,0,4.41,1.29,4.41,3.75v.22h-6.25c-4.41,0-7.16,2.17-7.16,5.73s2.65,5.84,6.87,5.84c2.46,0,4.63-.81,6.54-2.39v2.02h4.45v-11.87c0-4.37-2.83-6.87-7.83-6.87Zm3.38,14.29c-1.62,1.03-3.34,1.54-5.22,1.54-2.39,0-3.78-1.03-3.78-2.83s1.43-2.83,3.89-2.83h5.11v4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.03,108.31c-.88,.44-1.84,.66-2.83,.66-1.87,0-3.2-1.14-3.2-3.31v-8.08h5.22v-3.56h-5.22v-5.11h-4.44v5.11h-2.9v3.56h2.9v8.78c0,4.08,2.61,6.39,6.25,6.39,1.62,0,3.23-.44,4.81-1.29l-.59-3.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 544.4,
    y: 94.02,
    width: 4.45,
    height: 18.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.6,87.07c-1.36,0-2.46,.99-2.46,2.28s1.1,2.28,2.46,2.28,2.43-.99,2.43-2.28c0-1.21-1.1-2.28-2.43-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M578.57,103.2c.11-5.33-4.56-9.66-10.25-9.55-5.7,0-10.18,4.15-10.18,9.55s4.48,9.55,10.18,9.55c5.69,.11,10.36-4.23,10.25-9.55Zm-16.02,0c0-3.23,2.5-5.73,5.77-5.73s5.84,2.5,5.84,5.73-2.5,5.73-5.84,5.73-5.77-2.5-5.77-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M601.86,101.48v10.91h4.45v-12.2c0-4.08-2.53-6.54-6.69-6.54-2.61,0-5.33,.96-7.57,2.68v-2.31h-4.48v18.37h4.48v-12.79c1.65-1.47,3.75-2.31,5.7-2.31,2.65,0,4.11,1.54,4.11,4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M624.71,101.59l-2.06-.55c-2.54-.7-3.16-1.1-3.16-2.17,0-1.36,.99-2.02,3.01-2.02s4.34,.66,6.14,1.73l1.51-2.9c-2.06-1.29-4.85-2.02-7.53-2.02-4.59,0-7.39,2.09-7.39,5.62,0,1.32,.44,2.35,1.32,3.12,.92,.77,2.5,1.47,4.74,2.09l2.31,.62c2.31,.7,2.87,1.1,2.87,2.17,0,1.51-1.1,2.28-3.34,2.28-2.39,0-5-.77-7.16-2.09l-1.54,2.83c2.35,1.58,5.44,2.46,8.56,2.46,4.85,0,7.68-2.13,7.68-5.81,0-2.76-1.65-4.19-5.95-5.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M639.37,117.61l3.49-5.92c.26-.4,.37-.84,.37-1.25,0-1.29-1.14-2.31-2.5-2.31s-2.46,1.03-2.46,2.31c0,.92,.51,1.69,1.4,2.09l-1.65,4.45,1.36,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M678.24,97.4l-2.79-.77c-4.08-1.1-4.81-1.69-4.81-3.05,0-2.09,1.87-3.12,4.63-3.12,2.61,0,5.99,.96,8.74,2.43l2.09-3.82c-2.9-1.73-6.76-2.75-10.47-2.75-3.01,0-5.47,.66-7.35,1.95-1.87,1.29-2.83,3.16-2.83,5.66,.15,4.19,2.57,5.69,8.67,7.24l2.9,.73c3.67,.92,4.67,1.43,4.67,3.2,0,2.39-2.06,3.49-5.18,3.49s-6.91-1.03-9.96-2.83l-2.2,3.6c3.23,2.21,7.53,3.42,11.76,3.42,6.5,0,10.62-2.79,10.62-7.94-.15-4.45-2.79-5.84-8.49-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706.35,93.65c-2.5,0-4.59,.92-6.03,2.5v-2.13h-4.48v25.54h4.48v-9.33c1.43,1.58,3.53,2.54,6.03,2.54,4.92,.11,8.97-4.3,8.86-9.55,.11-5.25-3.93-9.66-8.86-9.55Zm2.94,13.67c-.99,1.07-2.28,1.62-3.86,1.62-2.21,0-4.04-.92-5.11-2.5v-6.47c1.07-1.58,2.9-2.5,5.11-2.5,1.58,0,2.87,.55,3.86,1.65,.99,1.07,1.51,2.43,1.51,4.08s-.51,3.01-1.51,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M733.35,93.65c-2.98,0-5.95,.81-8.49,2.39l1.43,3.12c1.95-1.29,3.97-1.95,6.03-1.95,2.9,0,4.41,1.29,4.41,3.75v.22h-6.25c-4.41,0-7.17,2.17-7.17,5.73s2.65,5.84,6.87,5.84c2.46,0,4.63-.81,6.54-2.39v2.02h4.45v-11.87c0-4.37-2.83-6.87-7.83-6.87Zm3.38,14.29c-1.62,1.03-3.34,1.54-5.22,1.54-2.39,0-3.78-1.03-3.78-2.83s1.43-2.83,3.89-2.83h5.11v4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M767.89,108.79l-3.45-1.91c-1.07,1.32-2.65,2.06-4.56,2.06-3.12,0-5.59-2.53-5.59-5.73s2.46-5.73,5.59-5.73c1.84,0,3.31,.63,4.45,1.91l3.42-1.91c-1.87-2.39-4.81-3.82-7.94-3.82-5.29-.11-9.99,4.37-9.88,9.55-.11,5.18,4.59,9.66,9.88,9.55,3.23,0,6.17-1.47,8.08-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M790.66,107.28c-1.36,1.29-3.2,1.95-5.51,1.95-2.98,0-4.96-1.73-5.44-4.63h14.84v-1.4c0-5.47-4.12-9.55-9.66-9.55s-9.66,4.22-9.66,9.52,4.15,9.59,9.77,9.59c3.09,0,5.95-1.14,8.12-3.16l-2.46-2.31Zm-5.73-10.18c1.51,0,2.79,.44,3.78,1.36,.99,.88,1.51,1.98,1.51,3.34h-10.51c.4-2.94,2.31-4.7,5.22-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M836.74,99.75c-.77,1.8-1.65,3.34-2.68,4.7l-5.03-5.33c4.08-2.06,5.66-3.82,5.66-6.87,0-3.42-2.9-5.95-6.83-5.95-4.19,0-7.42,2.87-7.42,6.58,0,1.65,.66,3.05,2.28,4.85l.4,.44c-4.7,2.35-6.5,4.52-6.5,7.61,0,4.37,3.56,6.98,9.26,6.98,3.12,0,5.8-.85,8.05-2.57l2.31,2.57,3.16-2.68-2.65-2.79c1.21-1.58,2.28-3.6,3.27-6.06l-3.27-1.47Zm-8.96-10.14c1.87,0,3.12,1.07,3.12,2.72s-.74,2.61-4.3,4.26l-.62-.66c-.92-.99-1.62-2.31-1.62-3.38,0-1.65,1.47-2.94,3.42-2.94Zm-1.76,19.47c-2.94,0-4.81-1.4-4.81-3.71,0-1.65,1.07-2.87,4.3-4.52l5.8,6.43c-1.65,1.21-3.42,1.8-5.29,1.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "256.25 140.02 264.54 140.02 264.54 161.7 269.35 161.7 269.35 140.02 277.64 140.02 277.64 135.8 256.25 135.8 256.25 140.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.26,142.83c-5.59,0-9.73,4.25-9.73,9.58s4.18,9.66,9.84,9.66c3.11,0,6-1.15,8.18-3.18l-2.48-2.33c-1.37,1.29-3.22,1.96-5.55,1.96-3,0-5-1.74-5.48-4.66h14.95v-1.41c0-5.51-4.14-9.62-9.73-9.62Zm-5.22,8.21c.41-2.96,2.33-4.74,5.25-4.74,1.52,0,2.81,.44,3.81,1.37,1,.89,1.52,2,1.52,3.37h-10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M320.12,158.22c-3.15,0-5.62-2.55-5.62-5.77s2.48-5.77,5.62-5.77c1.85,0,3.33,.63,4.48,1.92l3.44-1.92c-1.89-2.4-4.85-3.85-7.99-3.85-5.33-.11-10.06,4.4-9.95,9.62-.11,5.22,4.63,9.73,9.95,9.62,3.26,0,6.22-1.48,8.14-4l-3.48-1.92c-1.07,1.33-2.66,2.07-4.59,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.2,142.83c-2.63,0-5.37,.96-7.62,2.7v-9.73h-4.51v25.9h4.51v-12.88c1.67-1.48,3.77-2.33,5.74-2.33,2.66,0,4.14,1.55,4.14,4.22v10.99h4.48v-12.29c0-4.11-2.55-6.59-6.73-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.69,142.83c-2.63,0-5.37,.96-7.62,2.7v-2.33h-4.51v18.5h4.51v-12.88c1.67-1.48,3.77-2.33,5.74-2.33,2.66,0,4.14,1.55,4.14,4.22v10.99h4.48v-12.29c0-4.11-2.55-6.59-6.73-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M403.48,142.83c-5.74,0-10.25,4.18-10.25,9.62s4.51,9.62,10.25,9.62c5.74,.11,10.43-4.26,10.32-9.62,.11-5.37-4.59-9.73-10.32-9.62Zm0,15.39c-3.29,0-5.81-2.52-5.81-5.77s2.52-5.77,5.81-5.77,5.88,2.52,5.88,5.77-2.52,5.77-5.88,5.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 422.86,
    y: 135.8,
    width: 4.51,
    height: 25.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.73,142.83c-5.74,0-10.25,4.18-10.25,9.62s4.51,9.62,10.25,9.62c5.74,.11,10.43-4.26,10.32-9.62,.11-5.37-4.59-9.73-10.32-9.62Zm0,15.39c-3.29,0-5.81-2.52-5.81-5.77s2.52-5.77,5.81-5.77,5.88,2.52,5.88,5.77-2.52,5.77-5.88,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.18,145.35c-1.44-1.59-3.55-2.52-6.07-2.52-5-.11-8.99,4.29-8.92,9.58-.11,5.29,3.96,9.7,8.92,9.58,2.52,0,4.62-.92,6.07-2.52v.81c0,3.74-2.29,5.55-5.74,5.55-2.66,0-5.07-.67-7.25-2.04l-1.44,3.14c2.63,1.59,5.74,2.41,9.32,2.41,2.85,0,5.18-.74,6.92-2.26,1.78-1.52,2.66-3.77,2.66-6.81v-17.09h-4.48v2.15Zm0,10.32c-1.07,1.59-2.92,2.52-5.14,2.52-1.59,0-2.89-.55-3.88-1.63-1-1.11-1.52-2.48-1.52-4.14,0-3.26,2.29-5.77,5.4-5.77,2.22,0,4.07,.92,5.14,2.52v6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M502.93,156.85l-5.48-13.65h-4.74l8.21,19.09-.3,.59c-1.15,2.11-2.22,2.96-3.96,2.96-.92,0-1.92-.22-3.03-.67l-1.29,3.11c1.81,.67,3.48,1,4.92,1,3.4,0,5.74-1.81,7.33-5.77l8.18-20.31h-4.66l-5.18,13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M547.74,139.94c2.66,0,5.14,1.22,6.73,3.26l4-2.52c-2.48-3.26-6.44-5.25-10.77-5.25-7.33-.15-13.76,6.14-13.62,13.32-.15,7.18,6.29,13.47,13.62,13.32,4.33,0,8.29-2,10.77-5.25l-4-2.59c-1.67,2.07-4.07,3.33-6.73,3.33-4.85,0-8.58-3.96-8.58-8.81s3.74-8.81,8.58-8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.64,142.83c-5.74,0-10.25,4.18-10.25,9.62s4.51,9.62,10.25,9.62c5.74,.11,10.43-4.26,10.32-9.62,.11-5.37-4.59-9.73-10.32-9.62Zm0,15.39c-3.29,0-5.81-2.52-5.81-5.77s2.52-5.77,5.81-5.77,5.88,2.52,5.88,5.77-2.52,5.77-5.88,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M621.04,142.83c-2.85,0-5.25,.81-7.81,3-1.04-1.96-3.07-3-5.55-3s-4.96,.96-7.18,2.89v-2.52h-4.51v18.5h4.51v-13.21c1.78-1.44,3.29-2,5.22-2,2.37,0,3.85,1.52,3.85,4.22v10.99h4.48v-10.62c0-.92-.07-1.81-.26-2.59,1.63-1.33,3.48-2,5.51-2,2.37,0,3.81,1.52,3.81,4.22v10.99h4.51v-12.29c0-4.25-2.7-6.59-6.59-6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M662.26,142.83c-2.85,0-5.25,.81-7.81,3-1.04-1.96-3.07-3-5.55-3s-4.96,.96-7.18,2.89v-2.52h-4.51v18.5h4.51v-13.21c1.78-1.44,3.29-2,5.22-2,2.37,0,3.85,1.52,3.85,4.22v10.99h4.48v-10.62c0-.92-.07-1.81-.26-2.59,1.63-1.33,3.48-2,5.51-2,2.37,0,3.81,1.52,3.81,4.22v10.99h4.51v-12.29c0-4.25-2.7-6.59-6.59-6.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 678.79,
    y: 143.2,
    width: 4.48,
    height: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M681.01,136.21c-1.37,0-2.48,1-2.48,2.29s1.11,2.29,2.48,2.29,2.44-1,2.44-2.29c0-1.22-1.11-2.29-2.44-2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M702.36,150.82l-2.07-.55c-2.55-.7-3.18-1.11-3.18-2.18,0-1.37,1-2.04,3.03-2.04s4.37,.67,6.18,1.74l1.52-2.92c-2.07-1.29-4.88-2.04-7.58-2.04-4.63,0-7.44,2.11-7.44,5.66,0,1.33,.44,2.37,1.33,3.15,.92,.78,2.52,1.48,4.77,2.11l2.33,.63c2.33,.7,2.89,1.11,2.89,2.18,0,1.52-1.11,2.29-3.37,2.29-2.41,0-5.03-.78-7.21-2.11l-1.55,2.85c2.37,1.59,5.48,2.48,8.62,2.48,4.88,0,7.73-2.15,7.73-5.85,0-2.78-1.67-4.22-5.99-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.27,150.82l-2.07-.55c-2.55-.7-3.18-1.11-3.18-2.18,0-1.37,1-2.04,3.03-2.04s4.37,.67,6.18,1.74l1.52-2.92c-2.07-1.29-4.88-2.04-7.58-2.04-4.63,0-7.44,2.11-7.44,5.66,0,1.33,.44,2.37,1.33,3.15,.92,.78,2.52,1.48,4.77,2.11l2.33,.63c2.33,.7,2.89,1.11,2.89,2.18,0,1.52-1.11,2.29-3.37,2.29-2.41,0-5.03-.78-7.21-2.11l-1.55,2.85c2.37,1.59,5.48,2.48,8.62,2.48,4.88,0,7.73-2.15,7.73-5.85,0-2.78-1.67-4.22-5.99-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M743.8,136.21c-1.37,0-2.48,1-2.48,2.29s1.11,2.29,2.48,2.29,2.44-1,2.44-2.29c0-1.22-1.11-2.29-2.44-2.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 741.58,
    y: 143.2,
    width: 4.48,
    height: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M765.67,142.83c-5.74,0-10.25,4.18-10.25,9.62s4.51,9.62,10.25,9.62c5.74,.11,10.43-4.26,10.32-9.62,.11-5.37-4.59-9.73-10.32-9.62Zm0,15.39c-3.29,0-5.81-2.52-5.81-5.77s2.52-5.77,5.81-5.77,5.88,2.52,5.88,5.77-2.52,5.77-5.88,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M797.19,142.83c-2.63,0-5.37,.96-7.62,2.7v-2.33h-4.51v18.5h4.51v-12.88c1.67-1.48,3.77-2.33,5.74-2.33,2.66,0,4.14,1.55,4.14,4.22v10.99h4.48v-12.29c0-4.11-2.55-6.59-6.73-6.59Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 215.01,
    width: 2.61,
    height: 195.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.87,100.36s-.06-.09-.1-.13c-2.29-3.05-5.76-5.02-9.36-6.26s-7.39-1.82-11.12-2.63c-1.26-.27-2.57-.6-3.52-1.46-.42-.38-.77-.9-.8-1.47-.05-1.07,.98-1.86,1.94-2.32,4.81-2.29,11-1.21,14.76,2.56,3.08-3.08,6.16-6.16,9.24-9.24,.06-.06-2.32-2.05-2.54-2.22-.91-.7-1.87-1.34-2.87-1.91-1.96-1.13-4.07-1.96-6.23-2.63-1.99-.61-4.3-.75-6.37-.83-2.13-.08-4.28,.07-6.37,.51-4.24,.89-8.28,3.05-10.99,6.43-2.7,3.38-3.92,8.04-2.71,12.2,1.12,3.88,4.18,6.97,7.72,8.92,3.54,1.95,7.53,2.87,11.51,3.59,2.24,.4,4.55,.77,6.54,1.87,.56,.31,1.11,.71,1.32,1.32,.42,1.25-.86,2.4-2.06,2.94-4.79,2.18-10.87,1.07-14.59-2.64-3.08,3.08-6.16,6.16-9.24,9.24,4.39,4.39,10.38,7.13,16.57,7.58,3.76,.27,7.57-.28,11.11-1.58,2.75-1.01,5.37-2.51,7.32-4.69,4.13-4.61,4.47-12.14,.83-17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.3,106.95c-2.36,2.36-5.63,3.83-9.24,3.83-7.22,0-13.07-5.85-13.07-13.07s5.85-13.07,13.07-13.07c3.61,0,6.88,1.46,9.24,3.83l9.24-9.24c-4.73-4.73-11.26-7.66-18.48-7.66-14.44,0-26.14,11.7-26.14,26.14s11.7,26.14,26.14,26.14c7.22,0,13.75-2.93,18.48-7.66l-9.24-9.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "176.37 71.8 138.48 71.8 138.48 84.86 158.39 84.86 150.89 89.15 150.89 123.77 163.96 123.77 163.96 84.86 176.37 84.86 176.37 71.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.77,65.9l-.89-.41c-.2,.41-.4,.82-.6,1.24l.81,.41c.22-.42,.45-.83,.67-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.39,53.93l-1.35-.88c-.2,.3-.41,.61-.61,.91l1.28,.87c.22-.3,.46-.6,.68-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.13,60.13l-.82-.45c-.2,.35-.4,.69-.6,1.04l.75,.44c.22-.35,.44-.69,.67-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.21,61.83l-1.04-.57c-.22,.37-.44,.75-.65,1.12l.98,.58c.23-.38,.47-.76,.71-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.66,71.71l-.55-.21c-.15,.4-.31,.8-.46,1.2l.46,.2c.18-.4,.36-.8,.55-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.55,56.08l.97,.66c.24-.32,.49-.63,.73-.94l-1.03-.67c-.22,.32-.45,.64-.66,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.04,57.88c-.18,.32-.36,.63-.54,.95l1.09,.64c.2-.32,.4-.64,.61-.96l-1.16-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.91,49.61l-1.52-1.16c-.3,.39-.61,.78-.9,1.17l1.45,1.12c.16-.19,.31-.39,.48-.58,.16-.19,.33-.37,.5-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.46,70.5l-.68-.26c-.14,.34-.27,.68-.4,1.03l.6,.26c.15-.35,.31-.69,.47-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.84,41.86l-1.76-1.83c-.54,.51-1.09,1.03-1.62,1.56l1.71,1.72c.55-.49,1.11-.97,1.68-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.38,54.96c.34-.39,.68-.77,1.03-1.15l-1.31-1c-.32,.39-.65,.79-.96,1.19l1.25,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.07,49.23c.44-.43,.88-.85,1.33-1.27l-1.41-1.26c-.42,.45-.83,.91-1.24,1.37l1.32,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,59.8l1.26,.85c.26-.35,.53-.7,.8-1.05l-1.34-.87c-.24,.36-.48,.71-.71,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.16,57.68l-1.19-.78c-.23,.34-.47,.67-.7,1.01l1.14,.77c.25-.34,.5-.67,.76-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.45,50.78c-.17,.21-.35,.42-.52,.63-.14,.18-.27,.37-.41,.55l1.15,.89c.33-.38,.67-.76,1.02-1.13l-1.23-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.54,64.41l-.61-.28c-.18,.37-.35,.75-.53,1.13l.53,.27c.2-.38,.41-.75,.61-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.85,45.5l1.58,1.4c.43-.44,.86-.89,1.3-1.32l-1.66-1.48c-.42,.46-.82,.93-1.22,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.29,63.52l-1.12-.62c-.23,.41-.45,.82-.67,1.23l1.01,.59c.26-.41,.52-.81,.78-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.93,67.35l-.86-.4c-.22,.46-.43,.91-.64,1.38l.75,.38c.25-.46,.5-.91,.75-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.41,47.65c-.52,.47-1.03,.95-1.54,1.43l1.47,1.48c.5-.48,1-.95,1.51-1.41l-1.45-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.26,42.16c-.66,.49-1.3,.99-1.94,1.51l3.38,3.89c.6-.5,1.2-.99,1.82-1.47l-3.26-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.11,69.24l-.37-.14c-.11,.29-.22,.58-.33,.88l.31,.13c.13-.29,.26-.58,.39-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.91,32.79c-.83,.58-1.64,1.18-2.44,1.79l1.88,2.46c.82-.54,1.64-1.06,2.48-1.56l-1.91-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.9,51.08c-.42,.44-.83,.89-1.23,1.34l1.54,1.36s.09-.09,.14-.14c.36-.4,.73-.79,1.11-1.18l-1.55-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.72,29.68c-.98,.59-1.95,1.19-2.9,1.82l7.19,10.73c.82-.51,1.64-1,2.48-1.47l-6.77-11.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.46,19.37c-11.52,0-22.45,2.5-32.3,6.98l5.94,11.61c8.06-3.57,16.98-5.56,26.36-5.56,7.92,0,15.51,1.41,22.53,4l4.51-12.22c-8.42-3.11-17.53-4.81-27.03-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.78,26.98c-1.15,.55-2.29,1.13-3.41,1.74l6.59,11.24c.94-.5,1.88-.97,2.85-1.42l-6.03-11.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.39,36.27c-.81,.53-1.6,1.08-2.38,1.65l5.24,6.86c.7-.51,1.42-1,2.14-1.49l-5-7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.73,68.8c.1-.24,.2-.49,.31-.73l-.77-.29c-.09,.23-.18,.47-.27,.7l.73,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.53,48.96c-.42,.44-.85,.88-1.26,1.33l1.36,1.2c.43-.43,.87-.85,1.32-1.27l-1.42-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.72,56l1.43,1.11c.34-.4,.69-.79,1.04-1.18l-1.51-1.15c-.32,.4-.64,.81-.96,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.09,63.58l.92,.47c.18-.34,.35-.68,.53-1.01l-.97-.45c-.16,.33-.31,.66-.47,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.99,39.43c-.67,.52-1.33,1.05-1.98,1.59l1.59,1.83c.67-.49,1.35-.96,2.04-1.43l-1.65-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.85,42.91c-.54,.49-1.07,.99-1.59,1.5l1.47,1.48c.55-.47,1.11-.92,1.68-1.37l-1.55-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.75,46.96l-1.5-1.55c-.54,.47-1.07,.95-1.59,1.44l1.44,1.46c.54-.46,1.09-.9,1.64-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.22,38.49l-1.85-2.24c-.68,.56-1.35,1.13-2.01,1.71l1.79,2.06c.68-.52,1.37-1.03,2.07-1.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.53,160.01l-1.29-1.7c-.51,.35-1.02,.71-1.54,1.05l1.34,1.78c.5-.37,1-.75,1.49-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.16,156.88l-1.06-1.41c-.52,.34-1.04,.68-1.57,1l1.14,1.52c.5-.36,.99-.74,1.49-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.18,145.45l-1.11-1.13c-.32,.29-.66,.57-.99,.85l1.2,1.18c.3-.3,.6-.6,.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.62,155.26c.51-.35,1.01-.71,1.5-1.07l-1.09-1.44c-.51,.34-1.03,.67-1.56,1l1.14,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.19,163.16l-1.34-2.03c-.65,.38-1.3,.75-1.96,1.11l1.38,2.16c.64-.41,1.28-.82,1.91-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.64,156.58l-1.2-1.39c-.24,.19-.47,.39-.71,.58-.15,.12-.31,.23-.46,.34l1.25,1.43c.37-.32,.75-.64,1.12-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.48,154.24c.22-.19,.43-.38,.64-.57l-.95-1.1c-.4,.31-.81,.61-1.21,.91l1.02,1.17c.16-.14,.33-.27,.5-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.54,141.7l-.95-.85c-.32,.34-.64,.69-.97,1.02l1.05,.88c.3-.34,.59-.7,.88-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.52,147.83l-.93-.94c-.31,.28-.62,.55-.93,.82l.99,.97c.29-.28,.58-.56,.87-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.84,150.19l-.82-.84c-.29,.26-.59,.52-.88,.78l.88,.86c.27-.27,.56-.53,.83-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.34,148.21l1.29,1.47c.4-.33,.79-.67,1.18-1.01l-1.23-1.43c-.41,.32-.82,.65-1.23,.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.59,162.46l-1.21-2.12c-.77,.36-1.55,.7-2.33,1.02l1.24,2.3c.77-.39,1.54-.79,2.3-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.67,166.83l1.36,3.04c.95-.42,1.89-.86,2.82-1.31l-1.37-2.8c-.93,.38-1.87,.73-2.81,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.48,160.19c-1.05,.31-2.11,.6-3.18,.87l3.67,12.64c1.28-.32,2.55-.68,3.8-1.06l-4.29-12.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.08,156.93l-1.13-1.71c-.63,.35-1.26,.69-1.9,1.01l1.17,1.82c.63-.36,1.25-.74,1.86-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.94,151.14l-1.02-1.18c-.41,.32-.82,.62-1.23,.93l1.08,1.23c.39-.32,.79-.65,1.17-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.99,159.83l-1.16-1.76c-.64,.36-1.29,.7-1.94,1.04l1.21,1.9c.63-.38,1.26-.78,1.88-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.62,166.02l-1.36-2.39c-.79,.39-1.58,.76-2.38,1.12l1.39,2.58c.79-.42,1.58-.85,2.35-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.54,155.42c.61-.36,1.22-.74,1.82-1.12l-1.18-1.79c-.59,.38-1.18,.75-1.79,1.11l1.15,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.56,140.26l.69,.44c.12-.19,.24-.39,.36-.58l-.65-.45c-.14,.2-.27,.4-.41,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.99,145.34c.21-.28,.42-.56,.63-.84l-.8-.63c-.23,.28-.45,.57-.69,.85l.86,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.71,152.72c.5-.35,.99-.72,1.48-1.09l-1.28-1.68c-.12,.08-.23,.17-.35,.25,0,0,0,0,0,0-.38,.28-.76,.54-1.14,.81l1.29,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.55,137.97l-.28-.19c-.17,.24-.34,.48-.52,.72l.33,.21c.16-.24,.31-.49,.46-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.59,160.5c.76-.36,1.5-.74,2.24-1.12l-2.58-4.53c-.7,.38-1.4,.75-2.11,1.11l2.45,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.08,143.97l-.8-.71c-.3,.32-.59,.63-.9,.94l.86,.73c.28-.32,.56-.63,.83-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.6,172.02c1.11-.39,2.21-.81,3.3-1.25l-4.99-12.07c-.93,.35-1.87,.67-2.81,.98l4.51,12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.27,165.94c.92-.37,1.82-.76,2.72-1.17l-3.83-7.85c-.81,.37-1.63,.73-2.45,1.07l3.56,7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.91,161.37c-4.59,1.01-9.35,1.56-14.25,1.56-12.63,0-24.44-3.56-34.45-9.74l-6.89,11.2c12.02,7.41,26.18,11.69,41.34,11.69,6.13,0,12.09-.71,17.82-2.03l-3.57-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.53,146.17l-.65-.58c-.28,.29-.55,.58-.83,.86l.71,.6c.26-.29,.52-.58,.77-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.31,141.21c.27-.35,.54-.71,.8-1.07l-.65-.51c-.29,.35-.58,.7-.88,1.05l.72,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.49,152.88l-1.07-1.09c-.27,.25-.56,.49-.83,.74l1.14,1.12c.26-.25,.51-.51,.76-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.4,138l-.74-.59c-.32,.39-.66,.76-.99,1.14l.86,.63c.29-.39,.58-.79,.87-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.86,136.09l-.46-.32c-.21,.29-.42,.58-.63,.87l.53,.33c.19-.29,.37-.58,.56-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.63,148.63l1.02,.86c.23-.27,.46-.54,.68-.81l-.94-.84c-.25,.27-.51,.53-.76,.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.97,143.14c.24-.32,.48-.64,.71-.97l-.46-.37c-.26,.32-.52,.63-.79,.94l.54,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.48,133.73c-.24,.34-.48,.68-.72,1.02l.59,.37c.22-.34,.44-.68,.65-1.03l-.51-.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.67,127.39c-.45-.36-.89-.73-1.33-1.11l-1.31,1.31c.41,.44,.84,.86,1.27,1.28l1.37-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.63,123.68l-1.12,.93c.37,.49,.76,.97,1.15,1.44l1.24-1.09c-.43-.42-.85-.84-1.27-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.78,132.48c-.53-.32-1.05-.65-1.56-1l-1.19,1.44c.5,.42,1.01,.82,1.53,1.22l1.22-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.21,124.13c-.35-.43-.69-.86-1.02-1.3l-.54,.37c.29,.47,.6,.94,.91,1.4l.66-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.23,130.04c-.49-.38-.98-.78-1.45-1.19l-1.01,1.01c.45,.47,.9,.93,1.37,1.37l1.1-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.25,128.16l.91-.8c-.45-.44-.9-.89-1.33-1.36l-.79,.66c.39,.51,.8,1.01,1.21,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M92.16,131.37c-6.29,3.99-13.79,6.22-21.79,6.04-2.41-.06-4.77-.33-7.05-.81l-2.81,12.71c3.09,.65,6.28,1.04,9.55,1.11,10.67,.25,20.67-2.73,29.05-8.05l-6.96-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.82,126.53l-.77,.53c.32,.5,.65,.99,.99,1.48l.84-.6c-.36-.46-.72-.93-1.07-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.58,135.63l-3.87,12.34c.88,.3,1.76,.58,2.66,.84,.32,.08,.65,.17,.97,.24l2.91-12.69c-.9-.21-1.79-.46-2.66-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.77,130.2l-.93,.77c.44,.56,.89,1.11,1.35,1.65l1.01-.89c-.49-.5-.96-1.01-1.43-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.06,130.45c.46,.38,.92,.75,1.4,1.11l1.39-1.88c-.47-.3-.93-.61-1.38-.93l-1.41,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.31,136.62l1.26-2.16c-.64-.29-1.27-.6-1.9-.92l-1.27,1.9c.62,.41,1.26,.81,1.91,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.55,126.03c-.36-.44-.7-.89-1.04-1.35l-.52,.36c.31,.48,.63,.96,.95,1.43l.62-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.15,122.03c-.34-.41-.68-.82-1.01-1.24l-.82,.57c.28,.46,.57,.92,.87,1.36l.97-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.54,142.69c-.88-.35-1.76-.73-2.62-1.14l-1.24,2.31c.88,.51,1.77,1,2.68,1.45l1.18-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.28,144.28c-1.02-.28-2.04-.59-3.03-.95l-1.17,2.79c1.03,.47,2.08,.91,3.15,1.32l1.05-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.07,139.28c-.83-.29-1.65-.59-2.44-.92l-1.17,2.18c.81,.45,1.64,.87,2.47,1.26l1.13-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.31,135.2c-.77-.27-1.54-.56-2.29-.88l-3.44,8.22c.95,.41,1.93,.77,2.91,1.11l2.81-8.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.2,132.77c.57,.37,1.15,.73,1.74,1.07l1.18-2.03c-.54-.33-1.08-.67-1.6-1.02l-1.32,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.69,129.53c-.47-.47-.93-.95-1.38-1.44l-.75,.62c.42,.53,.84,1.05,1.28,1.57l.85-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.05,137.58c.75,.39,1.52,.74,2.3,1.08l2.24-4.98c-.65-.31-1.29-.64-1.93-.98l-2.62,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.7,137.99c-.29-.2-.59-.39-.88-.6-.31-.22-.61-.45-.92-.68l-1.2,1.46c.58,.5,1.17,.99,1.78,1.47l1.22-1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97,132.49c-.52-.42-1.03-.86-1.53-1.31l-.93,.93c.48,.5,.96,.98,1.46,1.46l1-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.79,137.52c-.69-.34-1.38-.69-2.05-1.08l-1.14,1.7c.67,.46,1.35,.91,2.05,1.34l1.15-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.68,134.97c-.55-.46-1.09-.94-1.61-1.42l-1.08,1.08c.51,.54,1.03,1.06,1.56,1.58l1.14-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.99,140.59c-.74-.39-1.48-.81-2.2-1.25l-1.25,1.86c.73,.52,1.46,1.02,2.22,1.5l1.23-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.65,136.71l1.1-1.49c-.56-.36-1.11-.74-1.67-1.15l-1.07,1.3c.27,.23,.54,.47,.82,.69,.27,.22,.55,.43,.83,.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.57,54.81l-.13-1.05c-.69,.07-1.38,.16-2.06,.26l.19,1.23c.66-.17,1.33-.32,2-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.03,58.37l-.18-1.42c-.66,.06-1.31,.15-1.97,.25l.25,1.61c.63-.16,1.26-.3,1.9-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.75,57.25l2.11,2.58c.75-.68,1.52-1.34,2.31-1.97l-1.76-2.52c-.91,.6-1.79,1.25-2.66,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.68,58.34l-1.24-2.19c-.78,.44-1.55,.91-2.3,1.39l1.52,2.31c.66-.52,1.33-1.03,2.02-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.32,47.31l.21,1.36c.73-.16,1.46-.3,2.2-.43l-.16-1.22c-.75,.08-1.5,.17-2.26,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.92,52.84l-.93-2.1c-.81,.34-1.61,.71-2.4,1.09l1.15,2.22c.72-.42,1.44-.82,2.18-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.9,55.18l-1.32-2.33c-.87,.47-1.72,.97-2.56,1.48l1.6,2.43c.74-.55,1.5-1.08,2.27-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.59,46.8l.06,1.05c.66-.07,1.32-.13,1.98-.17l-.04-.93c-.67,0-1.34,.02-2,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.76,50.93l-.02-.64c-.65,0-1.3,.02-1.94,.04l.04,.77c.64-.08,1.28-.13,1.93-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.51,58.21c-.61,.49-1.2,1-1.79,1.52-.3,.28-.6,.57-.9,.86l9.17,9.24c.61-.6,1.24-1.17,1.89-1.73l-8.37-9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.02,57.77l-.04-1c-.61-.01-1.22,0-1.84,.02l.07,1.2c.6-.09,1.2-.16,1.81-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.15,51.52l-.13-.99c-.72,.08-1.44,.17-2.15,.28l.18,1.14c.7-.16,1.39-.31,2.1-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.88,54.19l-.03-.65c-.63,0-1.26,0-1.89,.03l.05,.83c.62-.08,1.25-.16,1.87-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59,49.3l-.34-1.53c-.75,.15-1.49,.32-2.23,.51l.45,1.67c.71-.23,1.42-.45,2.13-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.47,55.86l-.32-1.42c-.65,.14-1.31,.3-1.95,.47l.42,1.58c.61-.23,1.23-.43,1.85-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.25,59.33l-.4-1.77c-.61,.13-1.22,.27-1.83,.43l.51,1.91c.57-.2,1.14-.39,1.71-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.12,59.11c-.7,.41-1.39,.85-2.08,1.31l3.01,4.56c.58-.38,1.17-.73,1.77-1.08l-2.71-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.35,56.07l-.86-1.95c-.74,.32-1.46,.67-2.18,1.03l1.07,2.07c.64-.4,1.3-.79,1.97-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.12,60.08c-.61,.28-1.21,.57-1.81,.88l1.08,2.09c.55-.28,1.11-.56,1.68-.82l-.95-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.97,61.44c-9.14,9.38-14.78,22.19-14.78,36.32h13.02c0-10.56,4.19-20.13,11-27.16l-9.24-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.64,58.54c-.81,.57-1.61,1.16-2.39,1.78l5.65,6.92c.6-.48,1.22-.94,1.85-1.39l-5.11-7.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.7,51.1c.17-.07,.34-.13,.51-.2l-.61-1.85c-.74,.23-1.47,.48-2.2,.74l.76,1.96c.51-.23,1.02-.46,1.53-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.75,59.24l-.91-2.06c-.67,.3-1.33,.62-1.98,.96l1.13,2.17c.58-.38,1.16-.74,1.76-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.28,54.16l-.54-1.65c-.15,.05-.31,.09-.46,.14-.52,.18-1.04,.37-1.55,.56l.69,1.78c.61-.29,1.24-.57,1.87-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.44,60.72l-.68-2.06c-.57,.19-1.14,.38-1.7,.6l.84,2.16c.51-.24,1.02-.48,1.54-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.35,57.41l-.58-1.78c-.62,.21-1.24,.43-1.85,.67l.74,1.9c.56-.28,1.12-.54,1.69-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.74,52.57l-.29-1.31c-.7,.15-1.39,.31-2.09,.49l.39,1.46c.66-.23,1.32-.45,1.99-.65Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCommunicationSpace);
export default __webpack_public_path__ + "static/media/LogoCommunicationSpace.23076422cbabdd2e7c91a1561468bfdf.svg";
export { ForwardRef as ReactComponent };